import React, { memo } from "react";
import {
  Stack,
  Typography,
  Card,
  CardContent,
} from "investira.react.components";
import {
  Info,
  InlineInfo,
  ModalInfo,
  CardInfo,
} from "../../../../components/molecules";
import { validators } from "investira.sdk";
import EmpresaPatrocinadores from "./EmpresaPatrocinadores";

const PrevidenciaSection = memo((props) => {
  const { pessoa } = props;

  if (validators.isEmpty(pessoa?.juridica?.previdencia)) {
    return null;
  }

  return (
    <Stack
      flexGrow={1}
      sx={{ minWidth: "288px" }}
      component="section"
      aria-label={`Previdência: ${pessoa.pessoa_fantasia || pessoa.pessoa}`}
    >
      <Card sx={{ height: "100%" }}>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack spacing={2} sx={{ py: 2 }}>
            <Stack>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
                component="h3"
              >
                Previdência
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ gap: 1 }}>
              <Stack
                sx={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <ModalInfo
                  label="Patrocinadores"
                  value={pessoa.juridica?.previdencia?.patrocinadores}
                  valueProps={{ variant: "h5" }}
                  copy={"none"}
                  type="card"
                  modalProps={{
                    pessoaId: pessoa.pessoa_id,
                  }}
                  modalContent={EmpresaPatrocinadores}
                  cardProps={{ variant: "outlined" }}
                />
              </Stack>
              <Stack
                sx={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <CardInfo
                  label="Origem do Patrocínio"
                  value={pessoa.juridica?.previdencia?.patrocinio}
                  valueProps={{ variant: "h5" }}
                  copy={"none"}
                  type="card"
                  cardProps={{ variant: "outlined" }}
                  // descriptionProps={{
                  //   sx: {
                  //     whiteSpace: "nowrap",
                  //   },
                  // }}
                />
              </Stack>
              <Stack
                sx={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <CardInfo
                  label="Planos"
                  value={pessoa.juridica?.previdencia?.planos}
                  valueProps={{ variant: "h5" }}
                  copy={"none"}
                  type="block"
                  cardProps={{ variant: "outlined" }}
                />
              </Stack>
            </Stack>
            <Stack direction="column" sx={{ gap: 1 }}>
              <InlineInfo
                label="Conselho Deliberativo"
                value={pessoa.juridica?.previdencia?.conselho_deliberativo}
                copy={"muted"}
              />
              <InlineInfo
                label="Conselho fiscal"
                value={pessoa.juridica?.previdencia?.conselho_fiscal}
                copy={"muted"}
              />
              <InlineInfo
                label="Diretor executivo"
                value={pessoa.juridica?.previdencia?.diretor_executivo}
                copy={"muted"}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default PrevidenciaSection;
